import { NgModule } from '@angular/core';
import { SessionTimerService } from './session-timer.service';
import { SessionTimeoutDialogComponent } from './session-timeout-dialog/session-timeout-dialog.component';
import { SessionExpiredDialogComponent } from './session-expired-dialog/session-expired-dialog.component';
import { WcgButtonComponent, WcgDialogModule } from '@wcg/frontend-framework';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [SessionTimeoutDialogComponent, SessionExpiredDialogComponent],
  imports: [MatDialogModule, WcgButtonComponent, WcgDialogModule],
  exports: [],
  providers: [SessionTimerService],
})
export class TimeoutModule {}
